import * as React from 'react'
import { StaticImage } from 'gatsby-plugin-image';
import {Link as GLink } from 'gatsby'
import iconLanguage from '../images/icons/language.svg';
import iconX from '../images/icons/x.svg';
import iconArrowUpBlue from '../images/icons/arrow-up-blue.svg';
import iconArrowDownBlue from '../images/icons/arrow-down-blue.svg';
import iconArrowLeftLongBlue from '../images/icons/arrow-left-long-blue.svg';
import iconArrowRightLongBlue from '../images/icons/arrow-right-long-blue.svg';
import iconCheckBlueThin from '../images/icons/check-blue-thin.svg';
import iconSocialLinkedin from '../images/icons/social-linkedin.svg';
import iconSocialInstagram from '../images/icons/social-instagram.svg';
import iconFeedbackQuote from '../images/icons/feedback_quote.svg';
import iconDropdownArrowDown from '../images/icons/dropdown-arrow-down.svg';
import iconDropdownArrowDownDark from '../images/icons/dropdown-arrow-down-dark.svg';
import iconBreadCrumpsHome from '../images/icons/bc_home.svg';
import iconBreadCrumpsRight from '../images/icons/bc_right.svg';
import iconFormDone from '../images/icons/form-done.svg';
import iconPhone from '../images/icons/phone.svg';
import logoTypeSign from '../images/logo/logo_Type_Sign.svg';
import logoTypeVertical from '../images/logo/logo_Type_Vertical.svg';
import logoTypeHorizontal from '../images/logo/logo_Type_Horizontal.svg';
import { capitalizeSmart } from '../utils/capitalizeSmart';

// ==============================
// Text
// ==============================
export const H1 = (props) => <h1 {...props} className={'text-l lg:text-xxl font-bold ' + (props.className?props.className:"")}>{props.children}</h1>
export const H2 = (props) => <h2 {...props} className={'text-m lg:text-xl font-bold ' + (props.className?props.className:"")}>{props.children}</h2>
export const H3 = (props) => <h3 {...props} className={'text-ss lg:text-l font-bold ' + (props.className?props.className:"")}>{props.children}</h3>
export const H4 = (props) => <h4 {...props} className={'text-s lg:text-m font-bold ' + (props.className?props.className:"")}>{props.children}</h4>
export const H5 = (props) => <h5 {...props} className={'text-xs lg:text-s font-bold ' + (props.className?props.className:"")}>{props.children}</h5>
export const H6 = (props) => <h5 {...props} className={'text-xxs lg:text-xs font-bold ' + (props.className?props.className:"")}>{props.children}</h5>
export const H7 = (props) => <h5 {...props} className={'text-xxxs lg:text-xxs font-bold ' + (props.className?props.className:"")}>{props.children}</h5>

export const T1 = (props) => <p {...props} className={'text-xs lg:text-s ' + (props.className?props.className:"")}>{props.children}</p>
export const T2 = (props) => <p {...props} className={'text-xxs lg:text-xs ' + (props.className?props.className:"")}>{props.children}</p>
export const T3 = (props) => <p {...props} className={'text-xxxs lg:text-xxs ' + (props.className?props.className:"")}>{props.children}</p>
export const T4 = (props) => <p {...props} className={'text-xxxxs lg:text-xxxs ' + (props.className?props.className:"")}>{props.children}</p>


// ==============================
// Buttons
// ==============================

export const Interactive = ({ children, className, label, tabIndex, downKey, onClick, ...props }) => {
    return (
        <span role="button" className={ className + " cursor-pointer" } 
            onClick={onClick} onKeyDown={(e) => { if (e.key === (downKey ? downKey : 'Enter')) { onClick(); } }} tabIndex={tabIndex ? tabIndex : -1} aria-label={label} {...props}>
                {children}
        </span>
    )
}

export const Circle = ({ children, borderColor }) => {
    return (
        <span className={"w-[16px] h-[16px] rounded-full bg-transparent border-2 box-border "+borderColor}></span>
    )
}

export const Button = ({ label, disabled, className, icon, iconColor, iconClassName, onClick }) => {
    return (
        <button className={ (className?className+" ":"")+(!label?"p-[12px]":"px-16 py-8") + " h-48 text-s whitespace-nowrap box-border bg-buttons-active-active hover:bg-buttons-active-hover transition-[background] disabled:bg-buttons-active-disable rounded-8 inline-flex justify-center items-center content-center gap-8"} disabled={disabled?true:false} onClick={onClick} title={label?label:""}>
            { label && 
                (<T1 className="text-text-secondary-main">{ label }</T1>)
            }
            { icon && icon === true &&
                <Circle borderColor="border-text-secondary-main" />
            }
            { icon && typeof icon === "string" &&
                <Icon type={icon} color={iconColor} className={iconClassName} />
            }
        </button>
    )
}

export const ButtonGradient = ({ label, disabled, icon, className, onClick }) => {    
    return (
        <button className={ (className?className+" ":"")+(!label?"p-[12px]":"px-16 py-8") + " h-48 whitespace-nowrap box-border bg-gradient-to-r from-buttons-active-active to-buttons-active-disable hover:from-buttons-active-disable  hover:to-buttons-active-active disabled:bg-buttons-active-disable rounded-8 inline-flex justify-center items-center content-center gap-8"} disabled={disabled?true:false} onClick={onClick} title={label?label:""}>
            { label && 
                (<T1 className="text-text-secondary-main">{ label }</T1>)
            }
            { icon &&
                <Circle borderColor="border-text-secondary-main" />
            }
        </button>
    )
}

export const ButtonOutlined = ({ label, disabled, icon, className, onClick }) => {
    return (
        <button className={ (className?className+" ":"")+(!label?"p-[12px]":"px-[14px] py-[6px]") + " h-48 text-s whitespace-nowrap box-border border border-buttons-active-active group hover:border-buttons-active-hover rounded-8 inline-flex justify-center items-center content-center gap-8"} disabled={disabled?true:false} onClick={onClick} title={label?label:""}>
            { label && 
                (<T1 className="text-text-accent-main group-hover:text-text-accent-hover transition-[color]">{ label }</T1>)
            }
            { icon &&
                <Circle borderColor="border-text-accent-main group-hover:border-buttons-accent-hover transition-[border-color]" />
            }
        </button>
    )
}

export const ButtonOutlinedBorderless = ({ label, disabled, icon, className, onClick }) => {
    return (
        <button className={ (className?className+" ":"")+(!label?"p-[12px]":"px-[16px] py-[8px]") + " h-48 text-s whitespace-nowrap rounded-8 inline-flex justify-center items-center content-center gap-8"} disabled={disabled?true:false} onClick={onClick} title={label?label:""}>
            { label && 
                (<T1 className="text-text-accent-main group-hover:text-text-accent-hover transition-[color]">{ label }</T1>)
            }
            { icon &&
                <Circle borderColor="border-text-accent-main group-hover:border-text-accent-hover transition-[border-color]" />
            }
        </button>
    )
}


// ==============================
// lOGO
export const Logo = ({ type, className }) => {
    switch (type) {
        case 'icon':
            return (
                <img className={className} src={logoTypeSign} alt="VanOnGo" placeholder='none'/>
            )
        case 'vertical':
            return (
                <img className={className} src={logoTypeVertical} alt="VanOnGo" placeholder='none'/>
            )
        case 'horizontal':
        default:
            return (
                <img className={className} src={logoTypeHorizontal} alt="VanOnGo" placeholder='none'/>
            )
    }    
}
// ==============================


// ==============================
// Chips
// ==============================
// round swaps the default rounded-8 corner for a full pill; every other styling
// stays as it is, so a caller omitting the prop renders exactly as before.
// color tints the chip in the caller's own colour — the surface at the same 15%
// the gains cards tint theirs with, the label solid — for a chip that belongs to
// something already carrying a colour, such as a step of a process.
export const Chip = ({ label, active, icon, className, round, color, ...props }) => {
    return (
        <div className={ (active!==true?"bg-surface-accent-accent hover:bg-buttons-secondary-hover cursor-pointer":"bg-buttons-active-active")+" transition-[background] whitespace-nowrap group "+(round?"rounded-full":"rounded-8")+" px-8 lg:px-16 py-4 lg:py-8 inline-flex justify-center items-center content-center gap-2 lg:gap-4 lg:gap-8"} style={color?{backgroundColor: color+'15'}:undefined} {...props}>
            { icon ?
                <div><Icon type={icon} size="12px" color={color?color:(!active?"#212b2f":"#ffffff")} /></div>
                :
              icon !== null ?
                <div className={ (!active?"border-text-secondary-secondary":"border-text-secondary-main")+' group-hover:border-text-secondary-main transition-[border] rounded-full border w-12 h-12'}></div>:
                null
            }
            <T2 className={ (!active?"text-text-secondary-secondary":"text-text-secondary-main")+' '} style={color?{color}:undefined}>{label}</T2>
        </div>
    )
}

// ==============================
// Counter
// ==============================
export const Counter = ({ value, active }) => {
    return (
        <div className={ (active!==true?"":"bg-buttons-active-active text-text-secondary-main")+" whitespace-nowrap hover:bg-buttons-active-active hover:text-text-secondary-main transition-[background,color] aspect-square rounded-full p-2 flex justify-center items-center content-center"}>
            <div>{value}</div>
        </div>
    )
}

// ==============================
// Icons
// ==============================

export const Icon = ({ type, className, color = undefined, size=undefined, style=undefined }) => {
    if (type && type.includes('pi-')) {
        return (<i className={(className?className:"")+" pi "+type+" "} style={{ ...style, color: color, fontSize: size }}></i>)
    } 
    else {
        switch (type) {
            case 'co2':
                return (
                    <StaticImage src='../images/icons/co2.png' alt="" className={className?className:""} placeholder='none'/>
                )
            case 'connect':
                return (
                    <StaticImage src='../images/icons/connect.png' alt="" className={className?className:""} placeholder='none'/>
                )
            case 'percent':
                return (
                    <StaticImage src='../images/icons/percent.png' alt="" className={className?className:""} placeholder='none'/>
                )
            case 'language':
                return (
                    <img src={iconLanguage} alt="" className={className?className:""} placeholder='none'/>
                )
            case 'menu':
                return (
                    <i className={(className?className:"")+"pi pi-bars"} style={{ color: color?color:'#1791ff' }}></i>
                )
            case 'x':
                return (
                    <img src={iconX} alt="" className={className?className:""} placeholder='none'/>
                )
            case 'arrow-down':
                return (
                    <StaticImage src='../images/icons/arrow-down.png' alt="" className={className?className:""} placeholder='none'/>
                )
            case 'arrow-down-blue':
                return (
                    <img src={iconArrowDownBlue} alt="" className={className?className:""} placeholder='none'/>
                )
            case 'arrow-up':
                return (
                    <StaticImage src='../images/icons/arrow-down.png' className={'rotate-180 '+(className?className:"")} alt="" placeholder='none'/>
                )
            case 'arrow-up-blue':
                return (
                    <img src={iconArrowUpBlue} alt="" className={className?className:""} placeholder='none'/>
                )
            case 'arrow-left-long-blue':
                return (
                    <img src={iconArrowLeftLongBlue} alt="" className={className?className:""} placeholder='none'/>
                )
            case 'arrow-right-long-blue':
                return (
                    <img src={iconArrowRightLongBlue} alt="" className={className?className:""} placeholder='none'/>
                )
            case 'arrow-right-long-white':
                return (
                    <StaticImage src='../images/icons/arrow-right-long-white.png' alt="" className={className?className:""} placeholder='none'/>
                )
            case 'check-blue':
                return (
                    <StaticImage src='../images/icons/check-blue.png' alt="" className={className?className:""} placeholder='none'/>
                )
            case 'check-blue-thin':
                return (
                    <img src={iconCheckBlueThin} alt="" className={className?className:""} placeholder='none' />
                )
            case 'extra-blue':
                return (
                    <StaticImage src='../images/icons/extra-blue.png' alt="" className={className?className:""} placeholder='none'/>
                )
            case 'social-linkedin':
                return (
                    <img src={iconSocialLinkedin} alt="" className={className?className:""} placeholder='none'/>
                )
            case 'social-instagram':
                return (
                    <img src={iconSocialInstagram} alt="" className={className?className:""} placeholder='none'/>
                )
            case 'feedback_quote':
                return (
                    <img src={iconFeedbackQuote} alt="" className={className?className:""} placeholder='none'/>
                )
            case 'dropdown-arrow-down':
                return (
                    <img src={iconDropdownArrowDown} alt="" className={className?className:""} placeholder='none'/>
                )
            case 'dropdown-arrow-down-dark':
                return (
                    <img src={iconDropdownArrowDownDark} alt="" className={className?className:""} placeholder='none'/>
                )
            case 'bc-home':
                return (
                    <img src={iconBreadCrumpsHome} alt="" className={className?className:""} placeholder='none'/>
                )
            case 'bc-right':
                return (
                    <img src={iconBreadCrumpsRight} alt="" className={className?className:""} placeholder='none'/>
                )
            case 'form-done':
                return (
                    <img src={iconFormDone} alt="" className={className?className:""} placeholder='none'/>
                )
            case 'phone':
                return (
                    <img src={iconPhone} alt="" className={className?className:""} placeholder='none'/>
                )
            case 'van':
            default:
                return (
                    <StaticImage src='../images/icons/van.png' alt="" className={className?className:""} placeholder='none'/>
                )
        }
    }
}

export const ButtonIcon = ({ icon, link, className = "", onClick }) => {
    return (
        <button to={link} className={(!className.includes("w-")&&!className.includes("h-")?"w-48":"")+" aspect-square flex justify-center items-center content-center cursor-pointer "+className} onClick={onClick}>
            <Icon type={icon} />
        </button>
    )
}

// ==============================
// Accordion
// ==============================

export const Accordion = ({ defaultIndex, items, className, onExpand }) => {
    let [expandedIndex, setExpandedIndex] = React.useState(defaultIndex);
    
    return (
        <div className={'flex flex-col lg:flex-row '+className}>
            { items.map((item, index) => {
                return (
                    <AccordionItem expanded={index===expandedIndex?true:false} setExpandedFunc={(expanded)=>expanded?(setExpandedIndex(index),onExpand(item)):(index===expandedIndex && !expanded && setExpandedIndex(-1))}
                        key={index} title={item.title} icon={item.icon} className={item.className} headerClassName={item.headerClassName} iconClassName={item.iconClassName} >
                        {item.content}
                    </AccordionItem>
                )
            })}
        </div>
    )
}

export const AccordionItem = ({ expanded, setExpandedFunc, title, icon, children, className, headerClassName, iconClassName }) => {    

    

    return (
        <div className={'transition-[height] flex flex-col '+className}>
            <Interactive onClick={(e) => setExpandedFunc(!expanded)} label={title}>
                <div className={'flex gap-8 lg:gap-16 justify-between items-center content-center '+headerClassName}>
                    { icon && <div className={iconClassName}><img src={icon} alt={title} /></div> }
                    <H4 className='grow'>{capitalizeSmart(title)}</H4>
                    <Icon type={'arrow-down-blue'} className={`flex justify-center items-center content-center cursor-pointer ${expanded?'rotate-180':''} transition-transform`} />
                </div>
            </Interactive>
            <div className={`${expanded?'max-h-900':'max-h-0'} overflow-hidden transition-[max-height]`}>
                {children}
            </div>
        </div>
    )
}

// ==============================
// Tab view
// ==============================

export const TabViewChipsed = ({ items, expandedIndex, setExpandedIndex, className, headerClassName, contentClassName, chipClassName }) => {

    return (
        <div className={className}>
            <div className={'flex flex-wrap items-center content-center gap-12 lg:gap-24 ' + (headerClassName?headerClassName:"")}> { items && items.map((item, index) =>
                <Interactive key={index} onClick={(e)=>setExpandedIndex(index)} label={item.title}>
                    <Chip label={item.title} icon={item.icon} active={index===expandedIndex} className={chipClassName} />
                </Interactive>
            )} </div>
            <div className={contentClassName}>
                { items && items.map((item, index) => (
                    <div key={index} className={`${expandedIndex===index?"block":"hidden"}`}>
                        {item.content}
                    </div>
                ))}
            </div>
        </div>
    )
}

export const TabPanel = ({ expanded, setExpandedFunc, title, icon, children, className, iconClassName }) => {
    return (
        <div className={'flex flex-col '+className}>
            <div className='flex gap-4 lg:gap-8 justify-between items-center content-center '>
                { icon && <div className={iconClassName}><Icon type={icon} /></div> }
                <H3 className='grow text-m lg:text-l font-bold'>{title}</H3>
                <ButtonIcon icon={expanded?'arrow-up':'arrow-down'} onClick={(e) => setExpandedFunc(!expanded)} className='flex justify-center items-center content-center h-16 lg:h-32 aspect-square cursor-pointer' />
            </div>
            <div className={ expanded?"":"hidden"}>
                {children}
            </div>
        </div>
    )
}

// ==============================
// Stepper
// ==============================

export const StepperVertical = ({ steps, activeIndex, setActiveIndex, containerClassName, stepClassNameActive, stepClassNameInactive, titleClassNameActive, titleClassNameInactive  }) => {
    return (
        <div className={`flex flex-col ${containerClassName}`}>
            {steps.map((step, index) => (
                <StepperPanel key={index} header={step.title}
                    stepNumber={index + 1} setActiveIndex={() => setActiveIndex(index)}
                    active={index === activeIndex} 
                    containerClassName={ index === activeIndex ? step.containerClassNameActive : step.containerClassNameInactive }
                    stepClassNameActive={step.stepClassNameActive} stepClassNameInactive={step.stepClassNameInactive} 
                    titleClassNameActive={step.titleClassNameActive} titleClassNameInactive={step.titleClassNameInactive}
                    contentClassName={step.contentClassName}>
                    {step.content}
                </StepperPanel>
            ))}
        </div>
    )
}

export const StepperPanel = ({ stepNumber, header, children, containerClassName, active, setActiveIndex, stepClassNameActive, stepClassNameInactive, titleClassNameActive, titleClassNameInactive, contentClassName }) => {
    return (
        <div className={`${containerClassName} transition-[height]`}>
            <Interactive onClick={setActiveIndex} label={`${stepNumber} - ${header}`}>
                <div className='flex gap-8 items-center content-center'>
                    <div className={active ? stepClassNameActive : stepClassNameInactive}>{stepNumber}</div>
                    <H5 className={active ? titleClassNameActive : titleClassNameInactive}>{header}</H5>
                </div>
            </Interactive>
            <div className={`${contentClassName} ${active ? "max-h-900" : "max-h-0"} overflow-hidden transition-[max-height]`}>
                {children}
            </div>
        </div>
    )
}


// ==============================
// Modal
// ==============================

export const Modal = ({ visible, minimized, title, children, className, onHide }) => {
    if ( !visible ) return;

    if ( minimized ) {
        //<div className='flex justify-end items-center content-center'>
            //<div className='bg-atomic-0'><ButtonIcon icon='x' onClick={onHide} /></div>
        //</div>
        return (
            <Interactive onClick={onHide} label='Close modal' downKey={'Escape'}>
            <div className={'fixed inset-0 z-50 bg-black bg-opacity-50 flex justify-center items-center content-center'}>
                <div className={'p-16 lg:p-32 flex gap-24 flex-col justify-start items-stretch content-stretch '+(className?className:"")}>
                    
                    <div className='grow flex flex-col justify-center items-stretch content-stretch'>
                        {children}
                    </div>
                </div>
            </div>
            </Interactive>
        )
    }

    return (
        <Interactive onClick={onHide} label='Close modal' downKey={'Escape'}>
        <div className={'fixed inset-0 z-50 bg-black bg-opacity-50 flex justify-center items-center content-center'}>
            <div className={'p-16 lg:p-32 bg-atomic-0 rounded-8 flex gap-24 flex-col justify-start items-stretch content-stretch '+(className?className:"")}>
                <div className='flex justify-end items-center content-center'>
                    { title?<H3 className="grow text-text-accent-main-2">{title}</H3>:null }
                    <ButtonIcon icon='x' onClick={onHide} />
                </div>
                <div className='grow flex flex-col justify-center items-stretch content-stretch'>
                    {children}
                </div>
            </div>
        </div>
        </Interactive>
    )
}

// ==============================
// Image Card
// ==============================

export const ImageCard = ({ image, title, children, className, imgClassName }) => {
    return (
        <div className={`border border-border-accent-light rounded-16 overflow-hidden ${className}`}>
            <img src={image} alt={title} className={`w-full object-cover ${imgClassName}`} />
            <div className='px-16 lg:px-24 py-8 lg:py-16 bg-white h-full'>
                {children}
            </div>                            
        </div>
    )
}

export const ImageCardDetailed = ({ image, note, title, note2, listitems, className, imgClassName }) => {
    return (
        <ImageCard image={image} title={title} className={className} imgClassName={imgClassName}>
                { note && <T3 className="text-text-accent-main uppercase">{note}</T3> }
                { title && <H4 className="text-text-accent-dark mt-4 lg:mt-8">{capitalizeSmart(title)}</H4> }
                { note2 && <H6 className="mt-4 lg:mt-8 text-text-accent-main font-bold">{note2}</H6> }
                <div>
                { listitems && listitems.map ((item, index) => {
                    return <div key={`img_${title}_${index}`} className='mt-4 lg:mt-8 flex gap-8 items-start content-center'>
                        <Icon type="check-blue-thin" className='mt-2 md:mt-4'/>
                        <T3>{item}</T3>
                    </div>
                })}
                </div>                       
        </ImageCard>
    )
}


// ==============================
// Round Image Text
// ==============================

// A round image to the left of its text, the two sharing one baseline. The whole
// entry becomes a link when an href is given.
export const RoundImageText = ({ image, text, href, className }) => {
    const classes = 'flex flex-row gap-8 lg:gap-16 items-center content-center ' + (className ? className : "");
    const content = <>
        { image && <img src={image} alt={text} className='size-[40px] lg:size-[56px] rounded-full object-cover' /> }
        <T1 className='font-bold text-text-accent-dark'>{text}</T1>
    </>;

    return href
        ? <GLink to={href} className={classes}>{content}</GLink>
        : <div className={classes}>{content}</div>
}


// ==============================
// Breadcrumps
// ==============================

export const Breadcrumbs = ({ items, locale, designData, layoutData, className }) => {
    return (
        <div className={'flex justify-start items-center content-center gap-6 lg:gap-8 '+className}>
            <GLink to={ layoutData?.header?.homepage_link ? layoutData.header.homepage_link : `/${locale}/` }><div className='flex items-center content-center gap-6 lg:gap-8 text-text-accent-dark'>
                <Icon type='bc-home'/>
                <span>{designData.breadcrumbs.home}</span>
            </div></GLink>
            { items.map((item, index) => 
                <span className='flex justify-start items-center content-center gap-6 lg:gap-8' key={`bc_span_${index}`}>
                    <Icon type={'bc-right'}  key={`bc_right_${index}`} />
                    { (index === items.length - 1 || !item.link) ? 
                        <span className='text-text-secondary-quaternary' key={`bc_item_${index}`}>{item.title}</span>
                        :
                        <GLink to={item.link} key={`bc_item_${index}`}>{item.title}</GLink>
                    }                    
                </span>
            )} 
        </div>
    )
}


// ==============================
// Inputs
// ==============================

export const Input = ({ label, note, placeholder, value, error, disabled, className, ...props }) => {
    return (
        <div className={className}>
            { label && <T2 className={'text-text-secondary-teritiary'}>{label}</T2> }
            <input placeholder={placeholder} value={value} disabled={disabled} className={className} {...props} />
            { error && <T4 className={'mt-4 md:mt-8 text-item-error-main'}>{error}</T4> } 
            { note && <T4 className={'mt-4 md:mt-8 text-text-secondary-teritiary'}>{note}</T4> }
        </div>
    )
}